import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
export const TargetAgeOrGrades = {
    it: 'IT',
    it1: 'IT1',
    it2: 'IT2',
    it3: 'IT3',
    pr: 'PR',
    pk: 'PK',
    tk: 'TK',
    kg: 'KG',
    g1: '01',
    g2: '02',
    g3: '03',
    ug: 'UG',
    unknown: 'unknown'
};
export const TargetAgeOrGrade = Type.Union([
    Type.Literal(TargetAgeOrGrades.it),
    Type.Literal(TargetAgeOrGrades.it1),
    Type.Literal(TargetAgeOrGrades.it2),
    Type.Literal(TargetAgeOrGrades.it3),
    Type.Literal(TargetAgeOrGrades.pr),
    Type.Literal(TargetAgeOrGrades.pk),
    Type.Literal(TargetAgeOrGrades.tk),
    Type.Literal(TargetAgeOrGrades.kg),
    Type.Literal(TargetAgeOrGrades.g1),
    Type.Literal(TargetAgeOrGrades.g2),
    Type.Literal(TargetAgeOrGrades.g3),
    Type.Literal(TargetAgeOrGrades.ug),
    Type.Literal(TargetAgeOrGrades.unknown)
]);
export const TargetAgeOrGradeCodec = createFallbackStringEnumCodec(TargetAgeOrGrades, TargetAgeOrGrades.unknown);
